import script from "./SmithInfoForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SmithInfoForm.vue?vue&type=script&setup=true&lang=js"

import "./SmithInfoForm.vue?vue&type=style&index=0&id=2156c898&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2156c898"]])

export default __exports__